// @flow
import { UserService } from 'SERVICES';

export default (query) => {  
  // if (!(query.token === 'invalid') && Object.keys(query).length >= 0) {
  //   UserService.checkNewPasswordToken(query.token).catch(err => window.location = '/new-password/invalid?invalid_token=true');
  // }
};
